import React from "react"
import "./About.css";
export default function About(){
   return(
       <main>
            <h1 className="about"><b>About</b></h1>
            <ul className="about--involvement">
                <li>International Student from Hong Kong</li>
                <li>Resident Assistant</li>
                <li>Research Assistant</li>
                <li>Vice-Chairperson of AIAA at UCSD</li>
            </ul>
       </main>
   )
}